"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxList = exports.useCheckboxList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var TriStateCheckbox_1 = require("../../components/TriStateCheckbox");
var Popover_1 = require("../../components/Popover");
var MDIcon_1 = require("../../components/MDIcon");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
var R = __importStar(require("../../utils/ramda"));
require("./CheckboxList.css");
var react_1 = require("react");
var useRandomGuid_1 = require("../../hooks/useRandomGuid");
var isType_1 = require("../../utils/isType");
var passFilter = function (text, filter) {
  var _filter = filter.trim().toLowerCase();
  if (_filter.length === 0) return true;
  if (!(0, isType_1.isString)(text)) return false;
  return text.toLowerCase().includes(_filter);
};
var useCheckboxList = function (initial, checkboxClickCallback) {
  var _a = __read((0, react_1.useState)(initial), 2),
    data = _a[0],
    setData = _a[1];
  var onCheckboxClick = function (id) {
    setData(function (prev) {
      var idx = prev.findIndex(function (o) {
        return o.id === id;
      });
      var item = prev[idx];
      var newState = item.state === TriStateCheckbox_1.TriState.Full ? TriStateCheckbox_1.TriState.Empty : TriStateCheckbox_1.TriState.Full;
      var newData = R.update(idx, R.assoc("state", newState, item), prev);
      return newData;
    });
    checkboxClickCallback && checkboxClickCallback(id);
  };
  var selectAll = function () {
    return setData(R.map(R.assoc("state", TriStateCheckbox_1.TriState.Full)));
  };
  var deselectAll = function () {
    return setData(R.map(R.assoc("state", TriStateCheckbox_1.TriState.Empty)));
  };
  var set = function (state, nodes) {
    return setData(R.map(function (node) {
      return nodes.includes(node.id) ? R.assoc("state", state, node) : node;
    }));
  };
  var setStateFiltered = function (text, selected) {
    var newState = selected ? TriStateCheckbox_1.TriState.Full : TriStateCheckbox_1.TriState.Empty;
    setData(function (prev) {
      return prev.map(function (d) {
        if (!(0, isType_1.isString)(d.label)) return d;
        var isMatch = passFilter(d.label, text);
        return isMatch ? R.assoc("state", newState, d) : d;
      });
    });
  };
  var config = {
    data: data,
    onCheckboxClick: onCheckboxClick
  };
  var util = {
    setData: setData,
    selectAll: selectAll,
    deselectAll: deselectAll,
    set: set,
    setStateFiltered: setStateFiltered
  };
  return [config, util];
};
exports.useCheckboxList = useCheckboxList;
var CheckboxList = function (_a) {
  var data = _a.data,
    _b = _a.onCheckboxClick,
    onCheckboxClick = _b === void 0 ? R.N : _b,
    _c = _a.actions,
    actions = _c === void 0 ? [] : _c,
    _d = _a.filter,
    filter = _d === void 0 ? "" : _d,
    rowGap = _a.rowGap,
    restProps = __rest(_a, ["data", "onCheckboxClick", "actions", "filter", "rowGap"]);
  var _e = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    guid = _e[0];
  var actionFunction = R.type(actions) === "Function" ? actions : function () {
    return actions;
  };
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    gap: "small"
  }, restProps, {
    children: data.map(function (option) {
      if (!passFilter(option.label, filter)) {
        return null;
      }
      return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center",
        gap: rowGap !== null && rowGap !== void 0 ? rowGap : "small"
      }, {
        children: [(0, jsx_runtime_1.jsx)(TriStateCheckbox_1.TriStateCheckbox, {
          id: "".concat(guid, "_").concat(option.id),
          value: option.state,
          onChange: function () {
            return onCheckboxClick(option.id);
          }
        }), (0, jsx_runtime_1.jsx)("label", __assign({
          htmlFor: "".concat(guid, "_").concat(option.id),
          className: "vsx-checkbox-list-label"
        }, {
          children: option.label
        })), option.info && (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
          content: option.info,
          interactive: false,
          tooltip: true,
          placement: "top"
        }, {
          children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            cursor: "pointer",
            icon: "information-outline"
          })
        })), (0, jsx_runtime_1.jsx)(ButtonActions, {
          optionId: option.id,
          actions: actionFunction(option.id)
        })]
      }), option.id);
    })
  }));
};
exports.CheckboxList = CheckboxList;
var ButtonActions = function (_a) {
  var optionId = _a.optionId,
    actions = _a.actions;
  return actions.length ? (0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
    paddingLeft: "medium",
    gap: "xs"
  }, {
    children: actions.map(function (action, idx) {
      var btn = (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        className: "vsx-checkbox-list-action-btn",
        cursor: "pointer",
        icon: action.icon,
        onClick: function () {
          return action.onClick(optionId);
        }
      }, idx);
      return R.isNothing(action.tooltip) ? btn : (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
        tooltip: true,
        placement: "top",
        interactive: false,
        content: action.tooltip
      }, action.tooltipProps, {
        children: btn
      }), idx);
    })
  })) : null;
};